import React from 'react'
import { FaCheck } from "react-icons/fa";



function Requirement({ htmlFor, isvalid, validMessage, invalidMessage }) {
    return (
        <label htmlFor={htmlFor} className={!isvalid ? `invalid` : `valid`}>
            <div className="d-flex">
               <span  className={` grey ${ isvalid ? 'green' : 'grey'}`}> <FaCheck /></span>
                <span >{!isvalid ? invalidMessage : validMessage}</span>
            </div>
        </label>
    )
}

export default Requirement
